import React, { useContext,useState,useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Button from '@mui/material/Button';
import { ModeContext } from './ModeContext';
import SidebarHistory from './SidebarHistory';
import SidebarHeader from './SidebarHeader';
import SidebarOption from './SidebarOption';
import SidebarFilelist from './SidebarFilelist';

import { loadTitleCache  } from './CacheHandler';

import DehazeIcon from '@mui/icons-material/Dehaze';
import { IconButton, List, ListItemButton, ListItemText, ListItemIcon, Badge, Typography, Divider } from '@mui/material';
import { Box } from '@mui/material'; 
import {
  Autorenew,
  AssignmentTurnedIn,
  DirectionsCar,
  Engineering,
  CheckCircle as CompleteIcon,
  Cancel as CancelIcon,
  Schedule as ScheduleIcon,
  ListAlt as ListAltIcon
} from '@mui/icons-material';

// 状態ごとのアイコンと色を返す
const getStatusConfig = (status) => {
  switch (status) {
    case '依頼中':
      return { icon: <Autorenew fontSize="small" />, color: '#ed6c02' };
    case '受取':
      return { icon: <AssignmentTurnedIn fontSize="small" />, color: '#1976d2' };
    case '移動中':
      return { icon: <DirectionsCar fontSize="small" />, color: '#1976d2' };
    case '作業中':
      return { icon: <Engineering fontSize="small" />, color: '#1976d2' };
    case '完了':
      return { icon: <CompleteIcon fontSize="small" />, color: '#2e7d32' };
    case 'キャンセル':
      return { icon: <CancelIcon fontSize="small" />, color: '#d32f2f' };
    default:
      return { icon: <ScheduleIcon fontSize="small" />, color: '#757575' };
  }
};

// 状態の表示順
const statusOrder = ['依頼中', '受取', '移動中', '作業中', '完了', 'キャンセル'];

// サイドバー用の状態リストコンポーネント
const RequestStatusList = ({ requestStatusCounts, requestStatusFilter, setRequestStatusFilter }) => {
  const totalCount = Object.values(requestStatusCounts).reduce((sum, c) => sum + c, 0);

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1, color: '#1976d2', fontWeight: 'bold' }}>
        状態別件数
      </Typography>
      <Divider sx={{ mb: 1 }} />
      <List dense disablePadding>
        {/* 全件表示 */}
        <ListItemButton
          selected={requestStatusFilter === ''}
          onClick={() => setRequestStatusFilter('')}
          sx={{ borderRadius: '6px', mb: 0.5, py: 0.5 }}
        >
          <ListItemIcon sx={{ minWidth: 32 }}>
            <ListAltIcon fontSize="small" sx={{ color: '#555' }} />
          </ListItemIcon>
          <ListItemText 
            primary="すべて" 
            primaryTypographyProps={{ fontSize: '0.85rem' }} 
          />
          <Badge 
            badgeContent={totalCount} 
            color="default"
            max={999}
            sx={{ '& .MuiBadge-badge': { fontSize: '0.7rem', minWidth: '20px', height: '20px' } }}
          />
        </ListItemButton>

        {/* 状態ごとのリスト */}
        {statusOrder.map(status => {
          const count = requestStatusCounts[status] || 0;
          if (count === 0) return null;
          const config = getStatusConfig(status);
          return (
            <ListItemButton
              key={status}
              selected={requestStatusFilter === status}
              onClick={() => setRequestStatusFilter(status)}
              sx={{ borderRadius: '6px', mb: 0.5, py: 0.5 }}
            >
              <ListItemIcon sx={{ minWidth: 32, color: config.color }}>
                {config.icon}
              </ListItemIcon>
              <ListItemText 
                primary={status} 
                primaryTypographyProps={{ fontSize: '0.85rem' }} 
              />
              <Badge 
                badgeContent={count} 
                sx={{ 
                  '& .MuiBadge-badge': { 
                    fontSize: '0.7rem', 
                    minWidth: '20px', 
                    height: '20px',
                    backgroundColor: config.color,
                    color: '#fff'
                  } 
                }}
                max={999}
              />
            </ListItemButton>
          );
        })}

        {/* データに含まれるが定義外の状態 */}
        {Object.keys(requestStatusCounts)
          .filter(s => !statusOrder.includes(s))
          .map(status => {
            const count = requestStatusCounts[status];
            const config = getStatusConfig(status);
            return (
              <ListItemButton
                key={status}
                selected={requestStatusFilter === status}
                onClick={() => setRequestStatusFilter(status)}
                sx={{ borderRadius: '6px', mb: 0.5, py: 0.5 }}
              >
                <ListItemIcon sx={{ minWidth: 32, color: config.color }}>
                  {config.icon}
                </ListItemIcon>
                <ListItemText 
                  primary={status} 
                  primaryTypographyProps={{ fontSize: '0.85rem' }} 
                />
                <Badge 
                  badgeContent={count} 
                  color="default"
                  max={999}
                  sx={{ '& .MuiBadge-badge': { fontSize: '0.7rem', minWidth: '20px', height: '20px' } }}
                />
              </ListItemButton>
            );
          })}
      </List>
    </Box>
  );
};

const Sidebar = ({chatHistorya,wkuser}) => {
  // モード管理の状態
  const { isUploadMode, setIsUploadMode,
    mode, setMode,
    messages, setMessages ,
    chatHistory,setChatHistory,
    fileList,setFileList,
    user,setUser,
    isComponentAVisible, setIsComponentAVisible,
    displayMode,
    requestStatusFilter, setRequestStatusFilter,
    requestStatusCounts } = useContext(ModeContext);

  const [isCollapsed, setIsCollapsed] = useState(false);
  // URL パラメータの取得
  const { search } = useParams();  
  const queryParams = new URLSearchParams(search);
  const userid = queryParams.get('userid');
  const category = queryParams.get('category');
  const bu = queryParams.get('bu');

  useEffect(() => {
    if (chatHistorya && chatHistorya.length > 0) {
      setChatHistory(chatHistorya);
    }
  }, [chatHistorya]);

  useEffect(() => {
    if (wkuser && wkuser.length > 0) {
      setUser(wkuser);
    }
  }, [wkuser]);

  const SomeComponent = () => {
    const { user } = useContext(ModeContext);
  
    useEffect(() => {
      console.log("✅ 現在のユーザー:", user);
    }, [user]);
  
    return <div>{user}現在のユーザー</div>;
  };

  return (
    <div className={`sidebar${isCollapsed ? 'collapsed' : ''}`}>
      {/* ハンバーガーメニュー */}
      <Box sx={{ display: "flex", flexDirection: "column", height: "100vh", width: "100%", bgcolor: "grey.100",flex: 1 }}>
        {/* ハンバーガーメニュー */}

        <Box sx={{display: "flex" , width: "100%", gap: 1}}>
          <SidebarHeader/>
        </Box>

        {/* 管理者メニュー押した*/} 

        <Box sx={{ flex: 1, overflowY: "auto", padding: 2, mt: 2,mb:3 } }>
          {displayMode === 'request' ? (
            <RequestStatusList 
              requestStatusCounts={requestStatusCounts}
              requestStatusFilter={requestStatusFilter}
              setRequestStatusFilter={setRequestStatusFilter}
            />
          ) : isUploadMode ? (
            <SidebarFilelist />
          ) : (
            <SidebarHistory chatHistory={chatHistory} setChatHistory={setChatHistory}/>
          )}
        </Box>

      </Box>
      {/* サイドバーコンテンツ */}
      {!isCollapsed && (
        <>
        </>
      )}
    </div>
  );
};

export default Sidebar;
